export class FUICommand {
    public title: string;
    public type: string;

    /**
     *
     */
    public onSelect(): void {}
}
